export default "__VITE_ASSET__a49e89c1__"